import React from 'react'

function ShiftNotes() {
  return (
    <div>ShiftNotes</div>
  )
}

export default ShiftNotes